"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAISparkleIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../../../../../../icons");
exports.StyledAISparkleIcon = (0, styled_components_1.default)(icons_1.AISparkleIcon) `
    margin: 0 auto 0 4px;
`;
